import { Link } from 'react-router-dom';

const quickLinks = [
  { label: '首页', to: '/' },
  { label: '全部赛事', to: '/category/all' },
  { label: '球队资料', to: '/teams' },
  { label: '球员数据', to: '/players' },
  { label: '篮球新闻', to: '/news' },
  { label: '关于我们', to: '/about' },
];

const leagues = [
  { label: 'NBA 美国职业篮球联赛', to: '/category/nba' },
  { label: 'CBA 中国男子篮球职业联赛', to: '/category/cba' },
  { label: 'EuroLeague 欧洲篮球联赛', to: '/category/euro' },
  { label: 'WNBA 女子职业篮球联赛', to: '/category/wnba' },
  { label: 'NCAA 美国大学篮球联赛', to: '/category/ncaa' },
  { label: 'FIBA 国家队赛事', to: '/category/fiba' },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100 mt-12">
      <div className="px-4 md:px-6 py-10 md:py-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        <div className="lg:col-span-1">
          <div className="flex items-center gap-2 mb-4">
            <span className="w-9 h-9 rounded-md bg-primary-500 flex items-center justify-center text-background-50">
              <i className="ri-basketball-line text-xl"></i>
            </span>
            <span className="font-heading font-extrabold text-lg text-background-50">篮球比分</span>
          </div>
          <p className="text-sm text-background-300 leading-relaxed">
            为篮球爱好者提供全面、及时的比分与数据查询服务，涵盖国内外多项篮球赛事与联赛。
          </p>
          <div className="flex items-center gap-3 mt-4">
            <span className="w-9 h-9 flex items-center justify-center rounded-md bg-secondary-800 text-background-200 cursor-pointer hover:bg-primary-500 hover:text-background-50 transition-colors">
              <i className="ri-wechat-line text-lg"></i>
            </span>
            <span className="w-9 h-9 flex items-center justify-center rounded-md bg-secondary-800 text-background-200 cursor-pointer hover:bg-primary-500 hover:text-background-50 transition-colors">
              <i className="ri-weibo-line text-lg"></i>
            </span>
            <span className="w-9 h-9 flex items-center justify-center rounded-md bg-secondary-800 text-background-200 cursor-pointer hover:bg-primary-500 hover:text-background-50 transition-colors">
              <i className="ri-mail-line text-lg"></i>
            </span>
          </div>
        </div>

        <div>
          <h3 className="font-heading font-bold text-background-50 mb-4">快速链接</h3>
          <ul className="space-y-2.5">
            {quickLinks.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-heading font-bold text-background-50 mb-4">热门联赛</h3>
          <ul className="space-y-2.5">
            {leagues.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-heading font-bold text-background-50 mb-4">联系方式</h3>
          <ul className="space-y-3 text-sm text-background-300">
            <li className="flex items-start gap-2">
              <span className="w-4 h-4 flex items-center justify-center mt-0.5 text-primary-400">
                <i className="ri-mail-send-line"></i>
              </span>
              contact@basketballscores.demo
            </li>
            <li className="flex items-start gap-2">
              <span className="w-4 h-4 flex items-center justify-center mt-0.5 text-primary-400">
                <i className="ri-customer-service-2-line"></i>
              </span>
              客服时间：工作日 09:00 - 18:00
            </li>
          </ul>
          <p className="mt-4 text-xs text-background-400 leading-relaxed">
            本站比分为演示数据，仅用于功能展示。
          </p>
        </div>
      </div>

      <div className="border-t border-secondary-800 px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
        <p className="text-xs text-background-400">© 2026 篮球比分 · 保留所有权利</p>
        <p className="text-xs text-background-400">本站内容为演示示例，未接入真实赛事数据接口</p>
      </div>
    </footer>
  );
}